import { Index } from '../ui/db-management/components/collections-table'

type ResponseServerSideError = {
    statusText: string
    errorMessage: string
}

const serverSideError = async function (response: Response): Promise<ResponseServerSideError> {
    let data
    if (response.status === 500) {
        try {
            data = await response.text()
            data = JSON.parse(data)
        } catch (ignored) {}
    }

    return {
        statusText: `${response.status} ${response.statusText}`,
        errorMessage: typeof data === 'string' ? data : data?.message
    }
}

export const responseHandlerGenerator = (
    onSuccess: (data: any) => void,
    onError: (statusText: string, errorMessage: string) => void,
    isJsonExpected: boolean
): ((response: Response) => Promise<void>) => {
    return async function (response): Promise<void> {
        if (response.ok) {
            const data = await (isJsonExpected ? response.json() : response.text())
            onSuccess(data)
        } else {
            const { statusText, errorMessage } = await serverSideError(response)
            onError(statusText, errorMessage)
        }
    }
}

export const errorHandlerGenerator = (endpoint: string): ((error: Error) => Promise<void>) => {
    return async function (error: Error): Promise<void> {
        if (error.name === 'AbortError') {
            console.debug(`Request to ${endpoint} was cancelled`)
        } else {
            console.warn(error.message)
            throw error
        }
    }
}

export const bytesToSize = function (bytes?: number | null | undefined): string {
    if (isNaN(bytes)) return '0 B'
    const sizes = ' KMGTPEZY'

    if (bytes === 0) return '0 B'
    const i = parseInt('' + Math.floor(Math.log(bytes) / Math.log(1024)))

    if (i === 0) return bytes.toFixed(0) + ' B'

    return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + (sizes[i] || '?') + 'B' || '0 B'
}

export const isTimestampIndex = (index: Index): boolean =>
    Object.keys(index.key).length === 1 && Object.keys(index.key).includes('timestamp')

export const isIdIndex = (index: Index): boolean =>
    Object.keys(index.key).length === 1 && Object.keys(index.key).includes('_id')

const REGULAR_PREFIX = 'events.'
const LONG_PREFIX = 'long_names.events.'

export const isLiveCollection = (collectionName: string): boolean =>
    collectionName.startsWith(REGULAR_PREFIX) || collectionName.startsWith(LONG_PREFIX)

export const isRegularCollectionName = (collectionName: string): boolean => collectionName.startsWith(REGULAR_PREFIX)

export const isLongCollectionName = (collectionName: string): boolean => collectionName.startsWith(LONG_PREFIX)
